module.exports = __webpack_public_path__ + "static/media/a88.146142d0.jpg";